import type { User } from 'features/users/types';
import type { TelephonyUser } from 'features/sip/types';

import { createSelector } from '@reduxjs/toolkit';
import { getUserDisplayName } from 'utils/getUserDisplayName';
import { selectAllHandRaisedParticipants } from 'features/users/selectors/selectAllHandRaisedParticipants';

export const selectAllHandRaisedForNotification = createSelector(
  [selectAllHandRaisedParticipants],
  (handRaisedEntities) => {
    const result: (User | TelephonyUser)[] = [];

    for (const user of Object.values(handRaisedEntities)) {
      result.push({
        ...user,
        name: getUserDisplayName(user),
      });
    }

    return result;
  }
);
